import { useState, useCallback } from 'react';
import { useSelector } from 'react-redux';

import { useAppDispatch } from '@store/hooks/useAppDispatch';
import { updateUserProfile } from '@reducers/membership';
import type { RootState } from '@store/types';

export interface UseManageEmailReportsReturn {
  subscribeForWeeklyDigest: boolean;
  isLoading: boolean;
  toggleWeeklyDigest: (value: boolean) => Promise<void>;
}

export const useManageEmailReports = (): UseManageEmailReportsReturn => {
  const dispatch = useAppDispatch();

  const userInfo = useSelector((state: RootState) => state.user?.userInfo);

  const [localSubscribeForWeeklyDigest, setLocalSubscribeForWeeklyDigest] = useState<boolean | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(false);

  const subscribeForWeeklyDigest = localSubscribeForWeeklyDigest ?? userInfo?.userProfile?.subscribeForWeeklyDigest ?? false;

  const toggleWeeklyDigest = useCallback(
    async (value: boolean) => {
      setIsLoading(true);
      const data = {
        emailAddress: userInfo?.emailAddress ?? '',
        userProfile: {
          ...userInfo?.userProfile,
          subscribeForWeeklyDigest: value,
        },
      };
      await dispatch(updateUserProfile(data));
      setLocalSubscribeForWeeklyDigest(value);
      setIsLoading(false);
    },
    [dispatch, userInfo],
  );

  return {
    subscribeForWeeklyDigest,
    isLoading,
    toggleWeeklyDigest,
  };
};
